import { render } from "./ImgCredited.vue?vue&type=template&id=8d05deee"
import script from "./ImgCredited.vue?vue&type=script&lang=js"
export * from "./ImgCredited.vue?vue&type=script&lang=js"

import "./ImgCredited.vue?vue&type=style&index=0&id=8d05deee&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__